var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.92a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,43.92,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.92,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.96,
    y: 94.67,
    width: 124.79,
    height: 132.89,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.46,
    y: 102.17,
    width: 109.79,
    height: 117.89,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.55 220.06 375.55 220.06 406.53 102.17 373.53 102.17 342.55 220.06",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.2 102.17 327.22 220.06 335.22 220.06 366.2 102.17 358.2 102.17",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.32 100.92 290.38 100.92 287.68 94.62 421.02 94.62 418.32 100.92",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.32 104.57 290.38 104.57 287.68 98.27 421.02 98.27 418.32 104.57",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.32 108.22 290.38 108.22 287.68 101.92 421.02 101.92 418.32 108.22",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.32 111.87 290.38 111.87 287.68 105.57 421.02 105.57 418.32 111.87",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.03,
    y: 86.73,
    width: 142.65,
    height: 8.4,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.49,171.29h0a1.45,1.45,0,0,1-1.45-1.45v-49a1.45,1.45,0,0,1,1.45-1.45h0a1.45,1.45,0,0,1,1.45,1.45v49A1.45,1.45,0,0,1,284.49,171.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.96,
    y: 93.45,
    width: 1.05,
    height: 29.1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.72,
    y: 92.1,
    width: 1.8,
    height: 140.37,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.77,
    y: 92.1,
    width: 1.8,
    height: 140.37,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.63 100.92 81.67 100.92 78.97 94.62 212.32 94.62 209.63 100.92",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.63 109.57 81.67 109.57 78.97 103.27 212.32 103.27 209.63 109.57",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.63 118.22 81.67 118.22 78.97 111.92 212.32 111.92 209.63 118.22",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.63 126.87 81.67 126.87 78.97 120.57 212.32 120.57 209.63 126.87",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.63 135.52 81.67 135.52 78.97 129.22 212.32 129.22 209.63 135.52",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.63 144.17 81.67 144.17 78.97 137.87 212.32 137.87 209.63 144.17",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.63 152.82 81.67 152.82 78.97 146.52 212.32 146.52 209.63 152.82",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.63 161.47 81.67 161.47 78.97 155.17 212.32 155.17 209.63 161.47",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.63 170.12 81.67 170.12 78.97 163.82 212.32 163.82 209.63 170.12",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.63 178.77 81.67 178.77 78.97 172.47 212.32 172.47 209.63 178.77",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.63 187.42 81.67 187.42 78.97 181.12 212.32 181.12 209.63 187.42",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.63 196.06 81.67 196.06 78.97 189.76 212.32 189.76 209.63 196.06",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.63 204.72 81.67 204.72 78.97 198.41 212.32 198.41 209.63 204.72",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.63 213.36 81.67 213.36 78.97 207.06 212.32 207.06 209.63 213.36",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.63 222.01 81.67 222.01 78.97 215.71 212.32 215.71 209.63 222.01",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.63 230.66 81.67 230.66 78.97 224.36 212.32 224.36 209.63 230.66",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.97,
    y: 230.66,
    width: 133.35,
    height: 3.6,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.32,
    y: 86.73,
    width: 142.65,
    height: 8.4,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.79,171.29h0a1.45,1.45,0,0,1-1.45-1.45v-49a1.45,1.45,0,0,1,1.45-1.45h0a1.45,1.45,0,0,1,1.45,1.45v49A1.45,1.45,0,0,1,75.79,171.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.26,
    y: 93.45,
    width: 1.05,
    height: 29.1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.32,322.38c-.12.13.55,1.07-2.19.66-6.75-1-18.5-3.75-21.77-10.69-4.67-9.91,9.81-6.29,9.31-11.36s-17-4.19-18.73-11.62,9.43-3.89,9.58-7.51-12.73-1.38-15.29-9.4,7.18-2.11,6.06-5.45-12-18.41-6.09-20.16S66.12,260.57,70,262.76s7.28-10.44,11.88-5.1-2.7,24,3.16,27.61c4.37,2.7,3.14-4.73,8.9-3.34C101.73,283.81,99.1,311.44,89.32,322.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.49,281.9a23.39,23.39,0,0,1,5.83,1.19,45.59,45.59,0,0,0-4.15-5.33.5.5,0,0,1,.71-.7,58.8,58.8,0,0,1,8.31,12.06c2.13-12.79-3.23-24-3.29-24.08a.38.38,0,0,1,.68-.33c.06.12,5.77,12.05,3.18,25.47.69,1.31,1.39,2.72,2.07,4.23a94.8,94.8,0,0,1,5.71,16.72,34.44,34.44,0,0,0,4-15.27.37.37,0,0,1,.38-.36.38.38,0,0,1,.37.39,34.57,34.57,0,0,1-4.47,16.29,116.42,116.42,0,0,1,2.53,34.45.5.5,0,0,1-.53.47h-.06a.49.49,0,0,1-.4-.53c1.23-18-1.45-32.41-5.17-43.35a13.74,13.74,0,0,0-8-4.55.39.39,0,0,1-.31-.43.37.37,0,0,1,.42-.32,14.19,14.19,0,0,1,7.28,3.62,83.6,83.6,0,0,0-8.52-17.33,20.77,20.77,0,0,0-6.63-1.56.38.38,0,0,1-.35-.4A.37.37,0,0,1,68.49,281.9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,326.21c5.61.1,15.19-5.11,19-10.17s-6.92-2-5.82-6,14.34-1.05,16.78-6.84-7.1-4.45-6.72-7.41,10.27-2.35,13.44-8.5-5.52-2.7-4.16-5.25,12.27-13.27,7.71-15.5-14.79,8.93-18.21,10.18-4.23-6.47-8.69-2.78-1.12,19.81-6.36,21.94c-3.91,1.59-2.25-5.8-6.75-3.93C90.26,295.22,95.69,326.16,98,326.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98,326.21c5.61.1,15.19-5.11,19-10.17s-6.92-2-5.82-6,14.34-1.05,16.78-6.84-7.1-4.45-6.72-7.41,10.27-2.35,13.44-8.5-5.52-2.7-4.16-5.25,12.27-13.27,7.71-15.5-14.79,8.93-18.21,10.18-4.23-6.47-8.69-2.78-1.12,19.81-6.36,21.94c-3.91,1.59-2.25-5.8-6.75-3.93C90.26,295.22,95.69,326.16,98,326.21Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.82,319.48a.38.38,0,0,1-.2-.17,29.47,29.47,0,0,1-2.52-15,.38.38,0,1,1,.75.06,30,30,0,0,0,2.27,14.28,115.29,115.29,0,0,1,8.54-18.06c-1-12,5.18-21.9,5.24-22a.37.37,0,1,1,.63.4,39,39,0,0,0-5.19,20.44,104.79,104.79,0,0,1,14.34-19.17.5.5,0,1,1,.7.71,97.48,97.48,0,0,0-10.95,13.84A29.62,29.62,0,0,1,124,292.91a.38.38,0,0,1,.36.39.37.37,0,0,1-.37.36h0a28.81,28.81,0,0,0-11.31,2.21,120,120,0,0,0-6.1,10.49,12.67,12.67,0,0,1,10.46-1.84.38.38,0,0,1,.27.46.37.37,0,0,1-.46.26,12.1,12.1,0,0,0-11.06,2.68A101.71,101.71,0,0,0,95,349a.5.5,0,0,1-.5.48h0A.5.5,0,0,1,94,349,98.68,98.68,0,0,1,99.82,319.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.19,381c-5.35-10.06-8.87-24.6-8.87-31a17.8,17.8,0,0,1,6.54-13.61h27.41A17.8,17.8,0,0,1,113.81,350c0,6.38-3.52,20.92-8.87,31Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-3",
    cx: 245.18,
    cy: 412.39,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.65,119.64h-24a3.5,3.5,0,0,0-3.34,2.73l-.16.75a8.5,8.5,0,0,1-8.14,6.65h-22.8a6.85,6.85,0,0,1-7-6.65l0-.75a2.8,2.8,0,0,0-2.86-2.73h-24a16.12,16.12,0,0,0-15.75,14.48L165.34,354.66a13.06,13.06,0,0,0,13.21,14.49h92.27a16.13,16.13,0,0,0,15.75-14.49l19.3-220.54A13.06,13.06,0,0,0,292.65,119.64Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.65,119.64h-24a3.5,3.5,0,0,0-3.34,2.73l-.16.75a8.5,8.5,0,0,1-8.14,6.65h-22.8a6.85,6.85,0,0,1-7-6.65l0-.75a2.8,2.8,0,0,0-2.86-2.73h-24a16.12,16.12,0,0,0-15.75,14.48L165.34,354.66a13.06,13.06,0,0,0,13.21,14.49h92.27a16.13,16.13,0,0,0,15.75-14.49l19.3-220.54A13.06,13.06,0,0,0,292.65,119.64Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.3,221.08h-49a2.91,2.91,0,0,1-2.94-3.22l3.69-42.19a3.58,3.58,0,0,1,3.5-3.22h49a2.9,2.9,0,0,1,2.94,3.22l-3.69,42.19A3.59,3.59,0,0,1,283.3,221.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,353H185a7.21,7.21,0,0,1-7.3-8h0a8.91,8.91,0,0,1,8.7-8h82a7.21,7.21,0,0,1,7.3,8h0A8.9,8.9,0,0,1,267,353Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.53,160.85H198.3a4,4,0,0,1-4.09-4.49l.61-7a5,5,0,0,1,4.88-4.48h75.23a4.05,4.05,0,0,1,4.1,4.48l-.62,7A5,5,0,0,1,273.53,160.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.83,149.12a1.39,1.39,0,0,1-1.36,1.25,1.13,1.13,0,0,1-1.14-1.25,1.38,1.38,0,0,1,1.36-1.24A1.12,1.12,0,0,1,288.83,149.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.5,152.86a1.38,1.38,0,0,1-1.35,1.25,1.13,1.13,0,0,1-1.14-1.25,1.38,1.38,0,0,1,1.35-1.25A1.13,1.13,0,0,1,288.5,152.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.18,156.59a1.39,1.39,0,0,1-1.36,1.25,1.13,1.13,0,0,1-1.14-1.25,1.39,1.39,0,0,1,1.36-1.25A1.13,1.13,0,0,1,288.18,156.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.21,290.68H185.68a2.9,2.9,0,0,1-2.94-3.22L187,239.31a3.58,3.58,0,0,1,3.5-3.22H282a2.9,2.9,0,0,1,2.93,3.22l-4.21,48.15A3.58,3.58,0,0,1,277.21,290.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.86,300.74h-28.5a.7.7,0,0,1-.71-.78h0a.87.87,0,0,1,.85-.79H211a.7.7,0,0,1,.71.79h0A.87.87,0,0,1,210.86,300.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.48,300.74H215.89a.7.7,0,0,1-.72-.78h0a.87.87,0,0,1,.85-.79h30.6a.7.7,0,0,1,.71.79h0A.87.87,0,0,1,246.48,300.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,307.69H181.76a.71.71,0,0,1-.72-.79h0a.88.88,0,0,1,.85-.79h19.28a.72.72,0,0,1,.72.79h0A.88.88,0,0,1,201,307.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.64,307.69H206.06a.71.71,0,0,1-.72-.79h0a.88.88,0,0,1,.86-.79h31.57a.71.71,0,0,1,.72.79h0A.87.87,0,0,1,237.64,307.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.54,314.63H181.15a.7.7,0,0,1-.72-.78h0a.88.88,0,0,1,.86-.79h51.39a.72.72,0,0,1,.72.79h0A.88.88,0,0,1,232.54,314.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,314.63h-3.39a.7.7,0,0,1-.72-.78h0a.87.87,0,0,1,.85-.79h3.4a.7.7,0,0,1,.71.79h0A.87.87,0,0,1,241,314.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.53,321.58h-24a.72.72,0,0,1-.72-.79h0a.88.88,0,0,1,.86-.79h24a.71.71,0,0,1,.72.79h0A.88.88,0,0,1,204.53,321.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.44,321.58H209.56a.72.72,0,0,1-.72-.79h0a.88.88,0,0,1,.86-.79h29.87a.71.71,0,0,1,.72.79h0A.88.88,0,0,1,239.44,321.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.48,328.52H179.93a.7.7,0,0,1-.71-.79h0a.87.87,0,0,1,.85-.78h29.54a.7.7,0,0,1,.72.78h0A.87.87,0,0,1,209.48,328.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.3,328.52H214.5a.7.7,0,0,1-.71-.79h0a.87.87,0,0,1,.85-.78h23.8a.7.7,0,0,1,.72.78h0A.88.88,0,0,1,238.3,328.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.14,217.08a1,1,0,0,1-1.42.09l-40.93-39.06a1,1,0,0,1,0-1.41h0a1,1,0,0,1,1.42-.09l40.93,39.06a1,1,0,0,1,0,1.41Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.17,217.07h0a1,1,0,0,1,.21-1.42l20.88-17.07a1,1,0,0,1,1.4.09h0a1,1,0,0,1-.21,1.41l-20.88,17.08A1,1,0,0,1,236.17,217.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.15,195h0a1,1,0,0,1,.21-1.41l20.92-17.1a1,1,0,0,1,1.4.09h0a1,1,0,0,1-.21,1.41l-20.92,17.1A1,1,0,0,1,263.15,195Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.14,217.08a1,1,0,0,1-1.42.09l-40.93-39.06a1,1,0,0,1,0-1.41h0a1,1,0,0,1,1.42-.09l40.93,39.06a1,1,0,0,1,0,1.41Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.17,217.07h0a1,1,0,0,1,.21-1.42l20.88-17.07a1,1,0,0,1,1.4.09h0a1,1,0,0,1-.21,1.41l-20.88,17.08A1,1,0,0,1,236.17,217.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.15,195h0a1,1,0,0,1,.21-1.41l20.92-17.1a1,1,0,0,1,1.4.09h0a1,1,0,0,1-.21,1.41l-20.92,17.1A1,1,0,0,1,263.15,195Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.74,114.84h-13A4.76,4.76,0,0,0,148,119.6v13a4.76,4.76,0,0,0,4.76,4.76h13a4.76,4.76,0,0,0,4.76-4.76v-13A4.76,4.76,0,0,0,165.74,114.84Zm-6.47,4.6c1.95,0,3,1.59,3,3.54s-1.05,3.54-3,3.54-3-1.58-3-3.54S157.31,119.44,159.27,119.44Zm7.81,13.27H151.45a.48.48,0,0,1-.34-.14l1-2.73a4.46,4.46,0,0,1,4.19-2.94h5.91a4.47,4.47,0,0,1,4.2,2.94l1,2.73A.46.46,0,0,1,167.08,132.71Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.74,114.84h-13A4.76,4.76,0,0,0,148,119.6v13a4.76,4.76,0,0,0,4.76,4.76h13a4.76,4.76,0,0,0,4.76-4.76v-13A4.76,4.76,0,0,0,165.74,114.84Zm-6.47,4.6c1.95,0,3,1.59,3,3.54s-1.05,3.54-3,3.54-3-1.58-3-3.54S157.31,119.44,159.27,119.44Zm7.81,13.27H151.45a.48.48,0,0,1-.34-.14l1-2.73a4.46,4.46,0,0,1,4.19-2.94h5.91a4.47,4.47,0,0,1,4.2,2.94l1,2.73A.46.46,0,0,1,167.08,132.71Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.66,168.12h-9.84a6.4,6.4,0,0,0-6.41,6.4v9.84a6.41,6.41,0,0,0,6.41,6.41h9.84a6.4,6.4,0,0,0,6.4-6.41v-9.84A6.39,6.39,0,0,0,119.66,168.12Zm-4.92,16.69s-4-4.39-4-6.63a4,4,0,0,1,8.09,0C118.78,180.42,114.74,184.81,114.74,184.81Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.74,176.34a1.85,1.85,0,1,0,1.84,1.84A1.84,1.84,0,0,0,114.74,176.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.66,168.12h-9.84a6.4,6.4,0,0,0-6.41,6.4v9.84a6.41,6.41,0,0,0,6.41,6.41h9.84a6.4,6.4,0,0,0,6.4-6.41v-9.84A6.39,6.39,0,0,0,119.66,168.12Zm-4.92,16.69s-4-4.39-4-6.63a4,4,0,0,1,8.09,0C118.78,180.42,114.74,184.81,114.74,184.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.74,176.34a1.85,1.85,0,1,0,1.84,1.84A1.84,1.84,0,0,0,114.74,176.34Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "335.7 140.23 342.29 135.97 335.7 131.7 335.7 140.23",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.19,124.34H331.63a5.35,5.35,0,0,0-5.35,5.35v12.56a5.36,5.36,0,0,0,5.35,5.35h12.56a5.35,5.35,0,0,0,5.35-5.35V129.69A5.34,5.34,0,0,0,344.19,124.34Zm-6.28,20a8.37,8.37,0,1,1,8.37-8.36A8.36,8.36,0,0,1,337.91,144.33Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "335.7 140.23 342.29 135.97 335.7 131.7 335.7 140.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.19,124.34H331.63a5.35,5.35,0,0,0-5.35,5.35v12.56a5.36,5.36,0,0,0,5.35,5.35h12.56a5.35,5.35,0,0,0,5.35-5.35V129.69A5.34,5.34,0,0,0,344.19,124.34Zm-6.28,20a8.37,8.37,0,1,1,8.37-8.36A8.36,8.36,0,0,1,337.91,144.33Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.52,172.51c0-.26,0-.52,0-.77l1.51-.84a9.92,9.92,0,0,0-.56-2.09l-1.72,0a8.52,8.52,0,0,0-.78-1.34l.89-1.47a10.61,10.61,0,0,0-1.53-1.54l-1.48.89a8.84,8.84,0,0,0-1.33-.77l0-1.73a10.89,10.89,0,0,0-2.09-.56l-.84,1.51c-.25,0-.51,0-.77,0s-.51,0-.77,0l-.84-1.51a11.29,11.29,0,0,0-2.09.56l0,1.73a8.37,8.37,0,0,0-1.33.77l-1.48-.89a10.19,10.19,0,0,0-1.54,1.54l.89,1.47a9.32,9.32,0,0,0-.77,1.34l-1.72,0a10.58,10.58,0,0,0-.57,2.09l1.51.84c0,.25,0,.51,0,.77s0,.52,0,.77l-1.51.84a10.4,10.4,0,0,0,.57,2.09l1.72,0a9.32,9.32,0,0,0,.77,1.34l-.89,1.48a10.61,10.61,0,0,0,1.54,1.53l1.48-.89a7.67,7.67,0,0,0,1.33.77l0,1.73a10.56,10.56,0,0,0,2.09.56l.84-1.51c.26,0,.51,0,.77,0s.52,0,.77,0l.84,1.51a10.2,10.2,0,0,0,2.09-.56l0-1.73a8.06,8.06,0,0,0,1.33-.77l1.48.89a11.06,11.06,0,0,0,1.53-1.53l-.89-1.48a8.52,8.52,0,0,0,.78-1.34l1.72,0a9.76,9.76,0,0,0,.56-2.09l-1.51-.84C356.5,173,356.52,172.77,356.52,172.51Zm-8.72,5.92a5.92,5.92,0,1,1,5.92-5.92A5.92,5.92,0,0,1,347.8,178.43Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.52,172.51c0-.26,0-.52,0-.77l1.51-.84a9.92,9.92,0,0,0-.56-2.09l-1.72,0a8.52,8.52,0,0,0-.78-1.34l.89-1.47a10.61,10.61,0,0,0-1.53-1.54l-1.48.89a8.84,8.84,0,0,0-1.33-.77l0-1.73a10.89,10.89,0,0,0-2.09-.56l-.84,1.51c-.25,0-.51,0-.77,0s-.51,0-.77,0l-.84-1.51a11.29,11.29,0,0,0-2.09.56l0,1.73a8.37,8.37,0,0,0-1.33.77l-1.48-.89a10.19,10.19,0,0,0-1.54,1.54l.89,1.47a9.32,9.32,0,0,0-.77,1.34l-1.72,0a10.58,10.58,0,0,0-.57,2.09l1.51.84c0,.25,0,.51,0,.77s0,.52,0,.77l-1.51.84a10.4,10.4,0,0,0,.57,2.09l1.72,0a9.32,9.32,0,0,0,.77,1.34l-.89,1.48a10.61,10.61,0,0,0,1.54,1.53l1.48-.89a7.67,7.67,0,0,0,1.33.77l0,1.73a10.56,10.56,0,0,0,2.09.56l.84-1.51c.26,0,.51,0,.77,0s.52,0,.77,0l.84,1.51a10.2,10.2,0,0,0,2.09-.56l0-1.73a8.06,8.06,0,0,0,1.33-.77l1.48.89a11.06,11.06,0,0,0,1.53-1.53l-.89-1.48a8.52,8.52,0,0,0,.78-1.34l1.72,0a9.76,9.76,0,0,0,.56-2.09l-1.51-.84C356.5,173,356.52,172.77,356.52,172.51Zm-8.72,5.92a5.92,5.92,0,1,1,5.92-5.92A5.92,5.92,0,0,1,347.8,178.43Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.73,202.24c0-.39,0-.77-.05-1.15l2.26-1.25a15.62,15.62,0,0,0-.84-3.14l-2.58.05a12.85,12.85,0,0,0-1.16-2l1.33-2.21a15.49,15.49,0,0,0-2.29-2.29l-2.21,1.32a13.65,13.65,0,0,0-2-1.15l0-2.58a15.35,15.35,0,0,0-3.13-.84l-1.25,2.26c-.38,0-.76,0-1.15,0s-.77,0-1.15,0L318.29,187a15.7,15.7,0,0,0-3.13.84l0,2.58a13.54,13.54,0,0,0-2,1.15L311,190.25a15.56,15.56,0,0,0-2.3,2.29l1.33,2.21a12.8,12.8,0,0,0-1.15,2l-2.58-.05a15,15,0,0,0-.84,3.14l2.26,1.25a11.05,11.05,0,0,0,0,2.3l-2.26,1.26a15.05,15.05,0,0,0,.84,3.13l2.58-.05a12.36,12.36,0,0,0,1.15,2l-1.33,2.21a15.56,15.56,0,0,0,2.3,2.29l2.21-1.32a12.7,12.7,0,0,0,2,1.15l0,2.58a15.05,15.05,0,0,0,3.13.84l1.26-2.26a11.05,11.05,0,0,0,2.3,0l1.25,2.26a14.73,14.73,0,0,0,3.13-.84l0-2.58a12.8,12.8,0,0,0,2-1.15l2.21,1.32a15.49,15.49,0,0,0,2.29-2.29l-1.33-2.21a12.41,12.41,0,0,0,1.16-2l2.58.05a15.7,15.7,0,0,0,.84-3.13l-2.26-1.26C333.71,203,333.73,202.63,333.73,202.24Zm-13,5.14a5.14,5.14,0,1,1,5.14-5.14A5.14,5.14,0,0,1,320.7,207.38Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.73,202.24c0-.39,0-.77-.05-1.15l2.26-1.25a15.62,15.62,0,0,0-.84-3.14l-2.58.05a12.85,12.85,0,0,0-1.16-2l1.33-2.21a15.49,15.49,0,0,0-2.29-2.29l-2.21,1.32a13.65,13.65,0,0,0-2-1.15l0-2.58a15.35,15.35,0,0,0-3.13-.84l-1.25,2.26c-.38,0-.76,0-1.15,0s-.77,0-1.15,0L318.29,187a15.7,15.7,0,0,0-3.13.84l0,2.58a13.54,13.54,0,0,0-2,1.15L311,190.25a15.56,15.56,0,0,0-2.3,2.29l1.33,2.21a12.8,12.8,0,0,0-1.15,2l-2.58-.05a15,15,0,0,0-.84,3.14l2.26,1.25a11.05,11.05,0,0,0,0,2.3l-2.26,1.26a15.05,15.05,0,0,0,.84,3.13l2.58-.05a12.36,12.36,0,0,0,1.15,2l-1.33,2.21a15.56,15.56,0,0,0,2.3,2.29l2.21-1.32a12.7,12.7,0,0,0,2,1.15l0,2.58a15.05,15.05,0,0,0,3.13.84l1.26-2.26a11.05,11.05,0,0,0,2.3,0l1.25,2.26a14.73,14.73,0,0,0,3.13-.84l0-2.58a12.8,12.8,0,0,0,2-1.15l2.21,1.32a15.49,15.49,0,0,0,2.29-2.29l-1.33-2.21a12.41,12.41,0,0,0,1.16-2l2.58.05a15.7,15.7,0,0,0,.84-3.13l-2.26-1.26C333.71,203,333.73,202.63,333.73,202.24Zm-13,5.14a5.14,5.14,0,1,1,5.14-5.14A5.14,5.14,0,0,1,320.7,207.38Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297,144.26v5.24l-5,2.63a1.22,1.22,0,0,0,0,2.15l5,2.63v5.24a2.11,2.11,0,0,0,2.11,2.11H317a2.12,2.12,0,0,0,2.12-2.11V144.26a2.12,2.12,0,0,0-2.12-2.12H299.08A2.11,2.11,0,0,0,297,144.26Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.12,149.72h10.17a1.25,1.25,0,0,0,0-2.5H303.12a1.25,1.25,0,0,0,0,2.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.29,152H303.12a1.25,1.25,0,0,0,0,2.5h10.17a1.25,1.25,0,0,0,0-2.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.29,156.69H303.12a1.25,1.25,0,0,0,0,2.5h10.17a1.25,1.25,0,0,0,0-2.5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.9,136h4.27l2.2,4.17a1.7,1.7,0,0,0,3,0l2.2-4.17h4.27a3.08,3.08,0,0,0,3.08-3.09V117a3.08,3.08,0,0,0-3.08-3.08H195.9a3.07,3.07,0,0,0-3.08,3.08V133A3.08,3.08,0,0,0,195.9,136Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.88 118.69 198.96 121.57 198.96 129.99 202.62 129.99 202.62 124.34 205.15 124.34 205.15 129.99 208.81 129.99 208.81 121.57 203.88 118.69",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.8,364.79H240l-2.45-4.66a1.42,1.42,0,0,0-2.5,0l-2.45,4.66H228.7a3.51,3.51,0,0,0-3.51,3.51v15.1a3.51,3.51,0,0,0,3.51,3.51h15.1a3.51,3.51,0,0,0,3.51-3.51V368.3A3.51,3.51,0,0,0,243.8,364.79Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.39,370.56a5.46,5.46,0,1,0-.77,8.36,1.26,1.26,0,0,0,.33.66l3.4,3.39a1.22,1.22,0,0,0,1.73-1.73l-3.39-3.39a1.23,1.23,0,0,0-.67-.34A5.48,5.48,0,0,0,238.39,370.56Zm-1.16,6.57a3.83,3.83,0,1,1,0-5.42A3.83,3.83,0,0,1,237.23,377.13Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.29,264.23s-8.15,20.2-16.13,22.38-20,.41-20,.41l-3.72,1-3.65-.54h-.13l-4.11-.1a.78.78,0,0,1-.7-1.23l1.47-2a1,1,0,0,1,.49-.35l3.92-1.26a1.08,1.08,0,0,1,.47,0l6,.95s16.65-2.73,18.35-4.27,6.71-17.69,6.71-17.69Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.57,283.36l-.39.06-6-.95a1.08,1.08,0,0,0-.47,0l-3.92,1.26a1,1,0,0,0-.49.35l-1.47,2a.78.78,0,0,0,.7,1.23l4.11.1h.13l2.45.36A15.7,15.7,0,0,0,369.57,283.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.21,244.22c-5.92-1.94-14.25,2.51-17.44,21.15L405.06,269S418.67,247,410.21,244.22Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.77,219.86c0,.62.33,1.11.73,1.11s.75-.53.72-1.13-.33-1.1-.73-1.09S375.77,219.25,375.77,219.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.19,220.47l-2.91,4.81s1,1.14,3.19.3Z",
    style: {
      fill: "#d4827d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.74,216a.31.31,0,0,1-.29.1,2.51,2.51,0,0,0-2.19.69.33.33,0,0,1-.45,0,.34.34,0,0,1,0-.46,3.11,3.11,0,0,1,2.76-.89.32.32,0,0,1,.28.36h0A.38.38,0,0,1,378.74,216Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.3,215.5c.45,8.13.82,11.57-2.77,16.19-5.73,4.95-15.49,5.74-18.37-2.09-2.59-7-2.89-19.13,4.63-23.32a11.11,11.11,0,0,1,15.12,4.31A11.29,11.29,0,0,1,399.3,215.5Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.97 233.29 390.03 245.34 400.07 243.02 396.56 230.72 387.97 233.29",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.74,216.1c.51-5.28-1.31.82-3.75-6.15s9.09-12.63,10.93-11.33.79,3.29,6.89,4.42a6.93,6.93,0,0,1,5.84,7.05s3.51,1.62,2.26,9.16a30.9,30.9,0,0,1-6,13.25s-2.31-2.38-6-.19a11.85,11.85,0,0,1-3.57-3.64c-1.64-2.46-2.15-4.8-4.4-5C378.24,223.24,380.57,217.84,380.74,216.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,211s5-3.06,2.78-6.27S401.63,208.27,400,211Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.17,219.17a6.28,6.28,0,0,0-1.59,4.53c.14,2.2,2.3,2.59,4,1.39s3.31-3.54,2.33-5.47A2.83,2.83,0,0,0,382.17,219.17Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.16,234.43l.82,4.78a9,9,0,0,1,2.26-6.53A4.05,4.05,0,0,0,388.16,234.43Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.7,
    y: 265.51,
    width: 2.87,
    height: 16.93,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.7,
    y: 265.51,
    width: 2.87,
    height: 16.93,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.85,231.89H290.7a4.85,4.85,0,0,0-4.85,4.85v33.13a4.85,4.85,0,0,0,4.85,4.85h7.15Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.35,
    y: 231.89,
    width: 58.08,
    height: 42.82,
    rx: 4.85,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.35,
    y: 231.89,
    width: 58.08,
    height: 42.82,
    rx: 4.85,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.35,
    y: 233.89,
    width: 54.08,
    height: 38.82,
    rx: 2.85,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.69,289.54a10.45,10.45,0,0,1,20.89,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.34 285.98 309.45 285.98 309.45 289.37 351.23 289.37 351.23 287.98 330.34 285.98",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.34 285.98 309.45 285.98 309.45 289.37 351.23 289.37 351.23 287.98 330.34 285.98",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.34 289.37 309.45 289.37 309.45 285.98 330.34 287.98 330.34 289.37",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.34 289.37 309.45 289.37 309.45 285.98 330.34 287.98 330.34 289.37",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.4,406.08H333.31a6.54,6.54,0,0,1-6.55-6.54V300.46a6.54,6.54,0,0,1,6.55-6.54H376.4a1.75,1.75,0,0,1,1.75,1.75h0a1.75,1.75,0,0,1-1.75,1.75H333.31a3,3,0,0,0-3.05,3v99.08a3,3,0,0,0,3.05,3H376.4a1.75,1.75,0,0,1,1.75,1.75h0A1.75,1.75,0,0,1,376.4,406.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.4,406.08H333.31a6.54,6.54,0,0,1-6.55-6.54V300.46a6.54,6.54,0,0,1,6.55-6.54H376.4a1.75,1.75,0,0,1,1.75,1.75h0a1.75,1.75,0,0,1-1.75,1.75H333.31a3,3,0,0,0-3.05,3v99.08a3,3,0,0,0,3.05,3H376.4a1.75,1.75,0,0,1,1.75,1.75h0A1.75,1.75,0,0,1,376.4,406.08Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 271.95,
    y: 289.37,
    width: 61.19,
    height: 5.13,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.95,
    y: 289.37,
    width: 61.19,
    height: 5.13,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.34,
    y: 289.37,
    width: 52.19,
    height: 5.13,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.34,
    y: 289.37,
    width: 52.19,
    height: 5.13,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.23 369.73 367.12 398.95 360.2 398.95 353.27 370.49 364.23 369.73",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.55,397l8.83.15a.71.71,0,0,1,.68.57l1.48,7.21a1.19,1.19,0,0,1-.91,1.4l-.25,0c-3.19-.11-6-.33-10-.4-4.67-.08-3.5.5-9,.49-3.31,0-3.85-3.79-2.45-3.95,6.45-.7,7.15-2.63,9.67-4.89A2.86,2.86,0,0,1,359.55,397Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.37 391.32 364.23 369.73 353.27 370.49 358.34 391.32 366.37 391.32",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.61,302.36l-28.38,1S345,316.73,344,327c-1.1,10.58,11.74,59.19,11.74,59.19h11.41s-3.15-35.67-4.35-46.59,39.79-7.31,46.91-16.62C416.22,314.44,411.61,302.36,411.61,302.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.61,302.36l-28.38,1S345,316.73,344,327c-1.1,10.58,11.74,59.19,11.74,59.19h11.41s-3.15-35.67-4.35-46.59,39.79-7.31,46.91-16.62C416.22,314.44,411.61,302.36,411.61,302.36Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.05 384.59 369.3 388.62 355.2 388.62 353.82 384.59 369.05 384.59",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.82 371.12 338.58 398.95 331.78 398.95 327.75 371.12 337.82 371.12",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.84,397l8.83.15a.71.71,0,0,1,.68.57l1.48,7.21a1.19,1.19,0,0,1-.91,1.4l-.25,0c-3.19-.11-6-.33-10-.4-4.68-.08-3.5.5-9,.49-3.31,0-3.85-3.79-2.45-3.95,6.45-.7,7.15-2.63,9.67-4.89A2.84,2.84,0,0,1,330.84,397Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.37,391.3l-.55-20.18H327.75l2.93,20.2C332.87,391.33,335.88,391.31,338.37,391.3Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.27,304.71s2.36,21.58-19.59,22.59-39.09,3.52-39.59,11.33,0,47.6,0,47.6H328.16s-4.64-25.16-6.45-40.76c-1.76-15.15-5-26.14,10.57-31.27,16.53-5.46,45.91-10.5,45.91-10.5l21.16-1.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.85 384.59 341.1 388.62 328 388.62 326.62 384.59 341.85 384.59",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,242.8s0-4.86-9.83-4.3c-10.44.6-8.47,5.26-8.47,5.26Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,242.8s0-4.86-9.83-4.3c-10.44.6-8.47,5.26-8.47,5.26Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.16,264.6c-.66,9.61-.43,38.52-.43,38.52s-21,1.38-37.48.84l-1.91-55.61a4.89,4.89,0,0,1,3.14-4.53c4.66-1.81,15.6-3.86,32.71-1.61C415.09,243,413.94,253.24,413.16,264.6Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.71,264.23s-8.16,20.2-16.13,22.38-20,.41-20,.41l-3.72,1-3.64-.54h-.13l-4.12-.1a.78.78,0,0,1-.7-1.23l1.48-2a1,1,0,0,1,.49-.35l3.91-1.26a1.12,1.12,0,0,1,.48,0l6,.95s16.65-2.73,18.34-4.27,6.72-17.69,6.72-17.69Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.5,254.83s-1.27,1.51-2.81,3.69l.55,16.1c6.13-2.71,8.56-18.49,8.56-18.49l-4-2.82Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.63,244.22c-5.92-1.94-14.26,2.51-17.45,21.15l12.3,3.59S390.09,247,381.63,244.22Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.21,
    y: 337.77,
    width: 9.25,
    height: 27.11,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.21,
    y: 337.77,
    width: 9.25,
    height: 27.11,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.89 389.44 390.89 355 378.77 355 378.77 389.44 351.18 393.27 351.18 397.1 384.83 394.23 418.48 397.1 418.48 393.27 390.89 389.44",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.78,
    cy: 402.84,
    r: 3.65,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.48,
    cy: 402.84,
    r: 3.65,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.83,
    cy: 402.84,
    r: 3.65,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.21,
    y: 337.77,
    width: 9.25,
    height: 6.7,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.4,276.32H391.26a9.52,9.52,0,0,0-9.47,8.63l-2.54,27.23a12.55,12.55,0,0,1-11.85,11.36L338.31,325a6.65,6.65,0,0,0-6.31,6.64v.61a5.51,5.51,0,0,0,5.51,5.51H426.1l4.77-51A9.52,9.52,0,0,0,421.4,276.32Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.4,276.32H391.26a9.52,9.52,0,0,0-9.47,8.63l-2.54,27.23a12.55,12.55,0,0,1-11.85,11.36L338.31,325a6.65,6.65,0,0,0-6.31,6.64v.61a5.51,5.51,0,0,0,5.51,5.51H426.1l4.77-51A9.52,9.52,0,0,0,421.4,276.32Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.22,307h4.15a0,0,0,0,1,0,0v21.71a2,2,0,0,1-2,2h-.15a2,2,0,0,1-2-2V307A0,0,0,0,1,352.22,307Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.22,307h4.15a0,0,0,0,1,0,0v21.71a2,2,0,0,1-2,2h-.15a2,2,0,0,1-2-2V307A0,0,0,0,1,352.22,307Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.23,300.77H363v7.65h9.25a3.83,3.83,0,1,0,0-7.65Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.23,300.77H363v7.65h9.25a3.83,3.83,0,1,0,0-7.65Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.52,
    y: 300.77,
    width: 39.71,
    height: 7.66,
    rx: 3.69,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.52,
    y: 300.77,
    width: 39.71,
    height: 7.66,
    rx: 3.69,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.18,337.77H383.87L388.81,285a9.52,9.52,0,0,1,9.47-8.63h30.14a9.52,9.52,0,0,1,9.47,10.4l-4.31,46.14A5.43,5.43,0,0,1,428.18,337.77Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.18,337.77H383.87L388.81,285a9.52,9.52,0,0,1,9.47-8.63h30.14a9.52,9.52,0,0,1,9.47,10.4l-4.31,46.14A5.43,5.43,0,0,1,428.18,337.77Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.67,406.08H281.58a6.54,6.54,0,0,1-6.55-6.54V300.46a6.54,6.54,0,0,1,6.55-6.54h43.09a1.75,1.75,0,0,1,1.75,1.75h0a1.75,1.75,0,0,1-1.75,1.75H281.58a3,3,0,0,0-3.05,3v99.08a3,3,0,0,0,3.05,3h43.09a1.75,1.75,0,0,1,1.75,1.75h0A1.75,1.75,0,0,1,324.67,406.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.67,406.08H281.58a6.54,6.54,0,0,1-6.55-6.54V300.46a6.54,6.54,0,0,1,6.55-6.54h43.09a1.75,1.75,0,0,1,1.75,1.75h0a1.75,1.75,0,0,1-1.75,1.75H281.58a3,3,0,0,0-3.05,3v99.08a3,3,0,0,0,3.05,3h43.09a1.75,1.75,0,0,1,1.75,1.75h0A1.75,1.75,0,0,1,324.67,406.08Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296.19,241.79l-3-2a.54.54,0,0,1,0-.91l3-2a.5.5,0,0,1,.69.14h0a.5.5,0,0,1-.14.68l-2.49,1.65,2.49,1.65a.5.5,0,0,1,.14.68h0A.51.51,0,0,1,296.19,241.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.83,241.65h0A.49.49,0,0,1,303,241l2.49-1.65L303,237.67a.49.49,0,0,1-.13-.68h0a.49.49,0,0,1,.68-.14l3,2a.54.54,0,0,1,0,.91l-3,2A.5.5,0,0,1,302.83,241.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.72,243h0a.49.49,0,0,1-.32-.62l2.07-6.54a.48.48,0,0,1,.61-.32h0a.48.48,0,0,1,.32.61l-2.06,6.55A.49.49,0,0,1,298.72,243Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.7,248H293.43a.51.51,0,0,1-.51-.52h0a.51.51,0,0,1,.51-.52H315.7a.52.52,0,0,1,.52.52h0A.52.52,0,0,1,315.7,248Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.28,248H319a.52.52,0,0,1-.52-.52h0A.52.52,0,0,1,319,247h22.26a.52.52,0,0,1,.52.52h0A.52.52,0,0,1,341.28,248Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.16,252.58H293.43a.51.51,0,0,1-.51-.52h0a.51.51,0,0,1,.51-.51h12.73a.52.52,0,0,1,.52.51h0A.52.52,0,0,1,306.16,252.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.32,252.58H309.47a.51.51,0,0,1-.51-.52h0a.51.51,0,0,1,.51-.51h20.85a.51.51,0,0,1,.51.51h0A.51.51,0,0,1,330.32,252.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.35,257.17H293.43a.52.52,0,0,1-.51-.52h0a.51.51,0,0,1,.51-.52h33.92a.52.52,0,0,1,.52.52h0A.52.52,0,0,1,327.35,257.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.75,257.17h-7.08a.52.52,0,0,1-.52-.52h0a.52.52,0,0,1,.52-.52h7.08a.52.52,0,0,1,.52.52h0A.52.52,0,0,1,337.75,257.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.27,261.75H293.43a.51.51,0,0,1-.51-.52h0a.51.51,0,0,1,.51-.52h15.84a.52.52,0,0,1,.52.52h0A.52.52,0,0,1,309.27,261.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.3,261.75H312.59a.52.52,0,0,1-.52-.52h0a.52.52,0,0,1,.52-.52H332.3a.52.52,0,0,1,.52.52h0A.52.52,0,0,1,332.3,261.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.7,266.33H293.43a.51.51,0,0,1-.51-.52h0a.51.51,0,0,1,.51-.51H315.7a.51.51,0,0,1,.52.51h0A.52.52,0,0,1,315.7,266.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.73,266.33H319a.52.52,0,0,1-.52-.52h0a.51.51,0,0,1,.52-.51h15.71a.51.51,0,0,1,.51.51h0A.51.51,0,0,1,334.73,266.33Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.47,176.82c.41,4.71-.61,13.24-4.16,16,5.79,2.09,11.93,5.69,15.85,10.44,3.89-5.66-.53-8.89-.53-8.89-5-1.78-4.47-5.57-3.18-9.06Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.4,172.76c-.06.59.22,1.1.61,1.14s.74-.42.8-1-.22-1.1-.61-1.14S160.47,172.17,160.4,172.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.05,171.77l1.45-.28S161.67,172.56,161.05,171.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.6,173.39a16.36,16.36,0,0,0,1.77,4,2.59,2.59,0,0,1-2.16.2Z",
    style: {
      fill: "#a24e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.08,169.65a.41.41,0,0,0,.24-.13.36.36,0,0,0,0-.49,3.48,3.48,0,0,0-3.09-.83.37.37,0,0,0-.11.49.33.33,0,0,0,.3.16,2.83,2.83,0,0,1,2.44.69A.36.36,0,0,0,162.08,169.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,169c-.23,7.31-.48,10.42,2.78,14.5,4.91,6.13,13.8,4.79,16.18-2.33,2.14-6.41,2.16-17.33-4.57-20.87S141.21,161.67,141,169Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.32,182.81c-7.19-1.23-5.13-5.76-5.13-5.76-7.08-1.43-1.61-4.89-1.61-4.89-5.89-2.54,0-4.82,0-4.82C128.9,162.63,137,161,137,161c-2-7.35,5-4.33,5-4.33,3.8-6.32,7.08-.29,7.08-.29,6.66-9,8.28-1.41,8.28-1.41,6.81-1.79,4.2,5.37,4.2,5.37,5.6,1.5,1.2,4.34,1.2,4.34,2.16,2.73-5.65,3.2-5.65,3.2s3.72,6,0,7.65l-9.46,7.25S143.28,181,141.32,182.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.39,176.91s5-12,1.09-22.24l3.3-1.13S157.09,168.43,148.39,176.91Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.38,175.59c.82,1.72,1.14,2.47,2.32,3a2.14,2.14,0,0,0,3.14-2.38c-.31-1.72-1.63-4.25-3.46-4.3A2.39,2.39,0,0,0,153.38,175.59Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.21,200.57s6.77,5,9.52,7l19.59-9.24h0a5.41,5.41,0,0,1,3.3-5.12l1.4-.58,2.95-1.32a3.42,3.42,0,0,1,3.41.36h0a3.43,3.43,0,0,1,1.27,3.74h0a8.47,8.47,0,0,1-6,5.82l-2.86.75S164,214.7,158,215s-14.79-5.59-14.79-5.59Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.93,192.14c5.17,0,10.95,3.22,20,9.12a24.85,24.85,0,0,1-7,11.08s-5-1.34-11.64-7.59C125.29,197.18,128.76,192.15,131.93,192.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.13,207.12h-49a2.91,2.91,0,0,1-2.94-3.22l3.69-42.18a3.58,3.58,0,0,1,3.5-3.22h49a2.9,2.9,0,0,1,2.93,3.22l-3.69,42.18A3.58,3.58,0,0,1,230.13,207.12Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.13,207.12h-49a2.91,2.91,0,0,1-2.94-3.22l3.69-42.18a3.58,3.58,0,0,1,3.5-3.22h49a2.9,2.9,0,0,1,2.93,3.22l-3.69,42.18A3.58,3.58,0,0,1,230.13,207.12Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.31,205.12a1.35,1.35,0,0,0,1.32-1.22l3.69-42.18a1.1,1.1,0,0,0-1.11-1.22h-49a1.36,1.36,0,0,0-1.33,1.22L180.2,203.9a1.1,1.1,0,0,0,1.11,1.22Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.26,180.32l-16,23.16,0,.42a1.1,1.1,0,0,0,1.11,1.22h27.76Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.26,180.32l-16,23.16,0,.42a1.1,1.1,0,0,0,1.11,1.22h27.76Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.77,202.29l-13.41-25.47-19.86,28.3h31.81a1.35,1.35,0,0,0,1.32-1.22Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.18,172.32a5,5,0,0,1-4.89,4.5,4.06,4.06,0,0,1-4.11-4.5,5,5,0,0,1,4.89-4.51A4.06,4.06,0,0,1,213.18,172.32Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.18,172.32a5,5,0,0,1-4.89,4.5,4.06,4.06,0,0,1-4.11-4.5,5,5,0,0,1,4.89-4.51A4.06,4.06,0,0,1,213.18,172.32Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.9 377.37 85.92 392.13 93.55 395.25 99.52 381.63 90.9 377.37",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.29,394.88a.25.25,0,0,1-.12-.23.21.21,0,0,1,.17-.18c.16,0,3.76-.84,5.1,0a1.14,1.14,0,0,1,.51.69.82.82,0,0,1-.26.91c-.51.36-1.7.21-2.79-.13A16.45,16.45,0,0,1,96.29,394.88Zm.76-.07c1.57.7,3.79,1.37,4.37.93.08-.06.18-.16.1-.47a.57.57,0,0,0-.32-.42,1.46,1.46,0,0,0-.38-.17A10,10,0,0,0,97.05,394.81Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.18,394.83a.22.22,0,0,1,0-.22c0-.1,1-2.4,2.41-3a1.65,1.65,0,0,1,1.27,0c.55.23.64.58.59.82-.12,1.05-2.82,2.3-4,2.44a.1.1,0,0,1-.09,0A.19.19,0,0,1,96.18,394.83ZM99.57,392a1.16,1.16,0,0,0-.8,0,5.1,5.1,0,0,0-2,2.33c1.29-.31,3.13-1.37,3.26-2,0-.06,0-.22-.34-.36l-.12,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.77,393.37l-9.58-3a.81.81,0,0,0-.94.37L81.11,398a1.34,1.34,0,0,0,.49,1.84,1.23,1.23,0,0,0,.26.12c3.47,1,6.6,1.76,10.9,3.1,5.08,1.56,3.6,1.77,9.54,3.7,3.58,1.16,5.5-2.73,4-3.4-6.71-3-6.78-5.36-8.7-8.69A3.22,3.22,0,0,0,95.77,393.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.51 384.45 96.51 388.49 99.52 381.63 90.9 377.37 88.51 384.45",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.72,240.85s-10.75,8.21-8.45,33.93c.22,2.38,1,4.87,1,7.59,0,1.81-.5,3.08-1.09,7.15-.86,5.92-2.44,28-4.11,30.87s-2.35,2.36-7,10.28c-5,8.52-11.5,23.46-16.53,48.78a28.2,28.2,0,0,0,11.24,4.71s27.47-43.32,33.31-59.45c5.23-14.43,11.46-60.48,11.46-60.48l.5-20Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.48,274.78H128.7s-2.56,24.48,5.9,44.9c.88-3.28,1.77-7.21,2.64-11.46l3.37-21.56c-.48-3.64-.85-6.42-.91-6.6C139.53,279.49,136.48,274.78,136.48,274.78Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.2 383.31 135.25 399 144.1 398.41 145.46 383.31 135.2 383.31",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.12,398.14a.21.21,0,0,1-.18-.17.21.21,0,0,1,.1-.23c.14-.08,3.27-2,4.82-1.66a1.17,1.17,0,0,1,.71.48.84.84,0,0,1,.05.95,4,4,0,0,1-2.68.79A15.65,15.65,0,0,1,145.12,398.14Zm.7-.31c1.71.15,4,.05,4.43-.56.06-.08.11-.21-.06-.48a.6.6,0,0,0-.44-.29,1.39,1.39,0,0,0-.41,0A9.7,9.7,0,0,0,145.82,397.83Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,398.14a.24.24,0,0,1-.11-.2c0-.11.17-2.6,1.3-3.6a1.61,1.61,0,0,1,1.2-.42c.6,0,.8.34.83.59.23,1-1.9,3.09-3,3.62a.14.14,0,0,1-.09,0A.19.19,0,0,1,145,398.14Zm2.26-3.8a1.12,1.12,0,0,0-.74.3,5.08,5.08,0,0,0-1.12,2.86c1.11-.71,2.5-2.32,2.42-2.94,0-.06-.05-.22-.44-.24l-.12,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.14,396.89l-10,.36a.81.81,0,0,0-.76.66l-1.52,8.22a1.34,1.34,0,0,0,1.06,1.57,1.43,1.43,0,0,0,.29,0c3.61-.2,6.81-.51,11.31-.66,5.31-.19,4,.49,10.23.36,3.77-.09,4.3-4.39,2.7-4.54-7.33-.66-8.17-2.84-11.08-5.35A3.22,3.22,0,0,0,144.14,396.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.23 391.43 144.75 391.23 145.46 383.31 135.2 383.31 135.23 391.43",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.71,238s-10.73,14.21-2.78,42l9,40.59s-8.54,18.46-4,67.16a41,41,0,0,0,13.24-.3s10-51.43,11.51-68.8c1.67-19.14.67-76.83.67-76.83Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.19,191.94s-1.66-7.1,9-4,9.76,9.17,9.76,9.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.19,191.94s-1.66-7.1,9-4,9.76,9.17,9.76,9.17Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.63,209.7c0,2.49-1,6.09-2,10.12-.46,1.91-.88,3.9-1.16,5.92-1.51,11-2,22.59-2,22.59a43.86,43.86,0,0,1-34.34-6.81s4.19-3.55,3.33-28.14c-.39-11.08-4.39-24.25,13.92-22.18,15.46,1.75,20.66,6.55,21.91,14.06,0,.09,0,.19,0,.29l.09.7A29.3,29.3,0,0,1,163.63,209.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.63,209.7c0,2.49-1,6.09-2,10.12-4.18-5-8.37-14.45-8.37-14.45l3.45-5.08,6.08,2.83a18,18,0,0,1,.5,2.14c0,.09,0,.19,0,.29l.09.7A29.3,29.3,0,0,1,163.63,209.7Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,205.36s6,5.92,8.37,8.3l20.74-6.22h0a5.42,5.42,0,0,1,4-4.56l1.46-.38,3.12-.86a3.45,3.45,0,0,1,3.32.87h0a3.42,3.42,0,0,1,.7,3.88h0a8.5,8.5,0,0,1-6.8,4.87l-2.94.31s-18.51,10.11-24.47,9.55-13.79-7.73-13.79-7.73Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.1,194.59c5.12.75,10.35,4.82,18.47,12a24.87,24.87,0,0,1-8.59,9.92s-4.73-2.07-10.37-9.24C147.79,198.59,152,194.13,155.1,194.59Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.d4b7fb62394cb7675dd0911fd968d844.svg";
export { ForwardRef as ReactComponent };